var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-diagnosis",
    d: "M12.909,2.914a2.279,2.279,0,0,0-2.227,2.329,2.229,2.229,0,1,0,4.454,0,2.279,2.279,0,0,0-2.227-2.329ZM4.064,4.606a.786.786,0,0,0-.675.4A1.868,1.868,0,0,0,2.2,5.985,2.011,2.011,0,0,0,2.331,8l2.847,4.253a.066.066,0,0,0,0,.008v.333a4.238,4.238,0,0,0,4.136,4.324,4.238,4.238,0,0,0,4.136-4.324V11.421a.84.84,0,0,0,.318-.661.8.8,0,1,0-1.591,0,.841.841,0,0,0,.318.661V12.59a3.26,3.26,0,0,1-3.181,3.327A3.26,3.26,0,0,1,6.132,12.59v-.333c0-.005,0-.011,0-.016L8.8,7.941a1.992,1.992,0,0,0,.075-1.986,1.869,1.869,0,0,0-.914-.868.793.793,0,0,0-.719-.481.832.832,0,0,0,0,1.663.767.767,0,0,0,.489-.181.929.929,0,0,1,.305.342A.969.969,0,0,1,8,7.4L5.639,11.2,3.113,7.424a.966.966,0,0,1-.062-.978A.9.9,0,0,1,3.5,6.02a.776.776,0,0,0,.567.249.832.832,0,0,0,0-1.663ZM10.6,8.237A1.218,1.218,0,0,0,9.409,9.479v3.633a3.967,3.967,0,0,0,.563,2.045,2.647,2.647,0,0,0,1.886-2.568V11.7a1.521,1.521,0,0,1-.318-.938,1.433,1.433,0,1,1,2.863,0,1.521,1.521,0,0,1-.318.938v.891a5.051,5.051,0,0,1-2.128,4.15,3.137,3.137,0,0,0,.7.136c.079.006.158.008.235.008a2.764,2.764,0,0,0,1.972-.8,4.17,4.17,0,0,0,1.13-3V9.425a1.142,1.142,0,0,0-1.107-1.164Z",
    transform: "translate(-1.994 -2.914)",
    fill: "#3673b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.80cbc0cb7164954cc933a0e85adff5be.svg";
export { ForwardRef as ReactComponent };